<template>
  <div>

    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">

          <router-link class="navbar-item logo" to="/">
            <img src="@/assets/images/SuportdArrel-net.png" width="330" height="140" />            
          </router-link>

          <h2 v-if="!currentUser" class="title is-spaced is-at-header is-hidden-touch">Vols afegir una iniciativa?</h2>
          <router-link v-if="!currentUser" to="/login" class="button is-danger is-at-header is-hidden-touch">Registra't i afegeix-la!</router-link>

          <a
            v-if="currentUser"
            role="button"
            class="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbarBasicExample" class="navbar-menu">


          <div class="navbar-start" v-if="currentUser && currentUser.emailVerified">            
            <router-link v-if="userBoxes && userBoxes.length > 0" class="navbar-item zhas-text-primary" to="/les-meves-iniciatives">Les meves iniciatives</router-link>
            <router-link v-if="!userBoxes || (userBoxes && userBoxes.length == 0)" class="navbar-item zhas-text-primary" to="/edita">Afegeix una iniciativa</router-link>
            <router-link class="navbar-item zhas-text-primary" to="/perfil">Les meves dades</router-link>
          </div>
          <div class="navbar-end" v-if="currentUser && currentUser.emailVerified">

          <a class="navbar-item" @click="logout">
            <span class="is-hidden-mobile">SORTIR</span>
            <i class="material-icons exit has-text-danger">
            exit_to_app
            </i>
          </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["currentUser", "userProfile", "userBoxes"])
  },
  mounted() {
    const $navbarBurgers = Array.prototype.slice.call(
      document.querySelectorAll(".navbar-burger"),
      0
    );

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach(el => {
        el.addEventListener("click", () => {
          // Get the target from the "data-target" attribute
          const target = el.dataset.target;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle("is-active");
          $target.classList.toggle("is-active");
        });
      });
    }
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/");
        })
        .catch(err => {
          console.log(err);
        });
    },
    test(){
      alert('x')
    }
  }
};
</script>
<style scoped>
nav{
  background: #fff;
  /* border-bottom: 1px solid #eee; */
}
.login-bar{
  background-color: #49c4af;
  height: 40px;  
  text-align: right;
  font-family: 'Varela Round';
}
.login-bar .tag{
  margin-right: 10px;
  font-weight: bold;
}
a.user-profile{
  text-transform: uppercase;
  line-height: 40px;  
  font-size: 13px;
  color:#fff;
  margin: auto 20px;
  display: inline-block;
  max-width: 85px;
}
a.user-profile:hover{
  color:#0a0a0a;
}
.button-logout{
  padding: 0;
  background-color: #5fd8c2;
  border-radius: 0;
  margin-left: 10px;
  text-transform: uppercase;
  color:#0a0a0a;
  font-size: 13px;
  line-height: 40px;
  height: 40px;
}
.button-logout:hover{
  background-color: #49c4af;
  color:#fff;
}
a.navbar-item.logo{
  text-transform: uppercase;
  font-weight: bold;
  color: #49C4AF;
  font-family: 'Varela Round';
  font-weight: bold;
  font-size: 24px;
}
a.navbar-item:not(.logo){
  color:#727475;
  font-size: 16px;
  font-family: 'Montserrat';
  padding: 0.5rem 1.25rem;
  text-transform: uppercase;
}
a.navbar-item:not(.logo):hover{
  color:#49C4AF;
}
.navbar-start{
  margin-left: .15rem;
}
.tag-notificacio:hover{
  color:#0a0a0a;
}
.tag-notificacio{
  vertical-align: 15px;
}
.person{
  vertical-align: -7px;
  margin-right: 4px;
}
.notifications{
  font-size: 18px;
  margin-left: 4px;
}
.exit{
  margin-left: 4px;
}
.ellipsis{
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logout {
  text-transform: uppercase;
  float: right;
}
.suport{
  font-size: 18px;
  padding-top: 30px;
}
.is-at-header{
  margin-top: 40px;
}
.is-at-header.button{
  margin-left: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue